import useSiteConfiguration from '@frontend/libs/hooks/useSiteConfiguration'
import { Spinner } from '@nextui-org/react'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/autoplay'
import { Autoplay, FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

export function NotificationBar() {
  const { error, isLoading, settings } = useSiteConfiguration()

  const notificationBar = settings?.notificationBar

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner size="lg" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex h-full items-center justify-center text-red-500">
        Error: {error.message}
      </div>
    )
  }

  if (!notificationBar?.enabled) {
    return null
  }

  return (
    <div className="bg-primary py-4">
      <Swiper
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
        }}
        freeMode={{
          enabled: true,
          sticky: true,
        }}
        loop={true}
        modules={[FreeMode, Autoplay]}
        slidesPerView={1}
      >
        {notificationBar.items?.map((item, index) => (
          <SwiperSlide key={index}>
            <div
              className="text-white text-center container"
              dangerouslySetInnerHTML={{ __html: item.text }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
